import Contact from "./components/Contact.vue";
import markerImage from "../images/marker-shop.png";

$("#contact-form").each(function () {
  new (Vue.extend(Contact))().$mount(this);
});

$("#map").each(function () {
  let [lat, lng] = LOCATION.latlng.split(",");
  lat = parseFloat(lat);
  lng = parseFloat(lng);

  const map = new google.maps.Map(this, {
    center: { lat, lng },
    zoom: LOCATION.zoom || 14,
    scrollwheel: false,
  });

  new google.maps.Marker({
    position: new google.maps.LatLng(lat, lng),
    icon: markerImage,
    map: map,
    title: "Test",
  });
});

$(document).ready(function () {
  $(".subject-dropdown").removeClass("active");
  $(".subject-label").removeClass("active");
  $(".subject-label input").on("click", function () {
    $(".subject-dropdown").addClass("active");
    $(this).parent().addClass("active");
  });

  $(".subject-dropdown ul li a").click(function () {
    var atag = $(this).text();
    $(".subject-label input").val(atag);
    $(".subject-dropdown").removeClass("active");
    $(".subject-label").removeClass("active");
    return false;
  });
});
